// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Form from "./components/Form.bs.js";
import * as React from "react";
import * as Button from "./components/Button.bs.js";
import * as Config from "./Config.bs.js";
import * as Layout from "./Layout.bs.js";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";

function MemberMenuPage(Props) {
  var url_eaten = Config.workflow === "prod" ? "https://liff.line.me/1656178160-G1PEyMX1/my-result" : "https://liff.line.me/1656154391-1rZ6YMnQ/my-result";
  React.useEffect((function () {
          RescriptReactRouter.replace("/member?lead_in_channel=menu");
          
        }), []);
  return React.createElement(Layout.Default.make, {
              children: React.createElement(Form.GroupInput.make, {
                    children: null,
                    className: "pt-14 space-y-12 items-center"
                  }, React.createElement(Button.make, {
                        label: "แก้ไขข้อมูลส่วนตัว",
                        disabled: false,
                        onClick: (function (param) {
                            return RescriptReactRouter.push("/edit");
                          })
                      }), React.createElement(Button.make, {
                        label: "โค้ดส่วนลด",
                        disabled: false,
                        onClick: (function (param) {
                            return RescriptReactRouter.push("/coupon");
                          })
                      }), React.createElement(Button.make, {
                        label: "คุณน่ากินแบบไหน",
                        disabled: false,
                        onClick: (function (param) {
                            window.open(url_eaten, "_self");
                            
                          })
                      })),
              hero: true
            });
}

var make = MemberMenuPage;

export {
  make ,
  
}
/* Form Not a pure module */
